import type { Locale } from "../i18n";

const legalCopy = {
	ja: {
		commercial: {
			metaTitle: "特定商取引法に基づく表記 - GSplat Share",
			metaDescription: "GSplat Share の特定商取引法に基づく表記です。",
			title: "特定商取引法に基づく表記",
			subtitle: "現在は無料ベータとして提供しています。",
			rows: [
				["サービス名", "GSplat Share"],
				["運営者", "Ryuto Haga"],
				["お問い合わせ", "contact@gsplat.org"],
				["販売価格", "無料ベータ中のため、現在公開している有料プランはありません。"],
				["追加料金", "現在はありません。"],
				["提供時期", "共有リンク作成後、すぐに利用できます。"],
			] as [string, string][],
		},
		contact: {
			metaTitle: "お問い合わせ - GSplat Share",
			metaDescription: "GSplat Share へのお問い合わせ先です。",
			title: "お問い合わせ",
			subtitle: "使い方のご質問や、不具合のご報告はこちらへ。",
			intro:
				"不具合については、問題が起きたときの操作、ファイル形式、お使いのブラウザをお知らせください。共有リンクに関するご相談は、そのURLも添えてください。",
			email: "contact@gsplat.org",
			cards: [
				{ label: "不具合", value: "開けないリンク、アップロード失敗、表示崩れなど。" },
				{ label: "形式", value: "PLY、SPZ、SOG、SuperSplat HTML について。" },
				{ label: "削除依頼", value: "共有リンクの削除や公開範囲の相談。" },
			],
			acceptedTitle: "お問い合わせの内容",
			acceptedBody: "個人運営のため、返信に時間がかかることがあります。",
		},
		pricing: {
			metaTitle: "無料ベータ - GSplat Share",
			metaDescription: "GSplat Share は現在無料ベータとして提供しています。",
			title: "無料ベータ",
			subtitle: "現在は無料でご利用いただけます。ベータ期間中は、仕様や提供内容が変わる場合があります。",
			backHome: "トップへ戻る",
		},
		privacy: {
			metaTitle: "プライバシーポリシー - GSplat Share",
			metaDescription: "GSplat Share のプライバシーポリシーです。",
			title: "プライバシーポリシー",
			subtitle: "共有リンクとアカウント情報の扱いについて。",
			sections: [
				{
					title: "取得する情報",
					body: "アップロードされたファイル、共有リンク設定、ログイン時のメールアドレスを扱います。",
				},
				{ title: "利用目的", body: "共有リンクの作成、表示、管理、問い合わせ対応のために利用します。" },
				{ title: "第三者提供", body: "法令に基づく場合を除き、本人の同意なく第三者に提供しません。" },
				{ title: "お問い合わせ", body: "個人情報に関するお問い合わせは contact@gsplat.org までご連絡ください。" },
			],
		},
		terms: {
			metaTitle: "利用規約 - GSplat Share",
			metaDescription: "GSplat Share の利用規約です。",
			title: "利用規約",
			subtitle: "GSplat Share を利用する前にご確認ください。",
			sections: [
				{ title: "利用範囲", body: "3Dデータをブラウザで閲覧できるリンクとして共有する目的で利用できます。" },
				{ title: "禁止事項", body: "権利を侵害するファイル、違法な内容、過度な負荷をかける利用は禁止します。" },
				{ title: "公開設定", body: "共有リンクの公開範囲、期限、パスワードは利用者の責任で管理してください。" },
				{ title: "変更", body: "本サービスは無料ベータ中のため、仕様や提供内容を変更することがあります。" },
			],
		},
	},
	en: {
		commercial: {
			metaTitle: "Commercial Disclosure - GSplat Share",
			metaDescription: "Commercial disclosure for GSplat Share.",
			title: "Commercial Disclosure",
			subtitle: "GSplat Share is currently provided as a free beta.",
			rows: [
				["Service", "GSplat Share"],
				["Operator", "Ryuto Haga"],
				["Contact", "contact@gsplat.org"],
				["Price", "No paid public plans are available during the free beta."],
				["Additional fees", "None at this time."],
				["Availability", "Share links are available immediately after creation."],
			] as [string, string][],
		},
		contact: {
			metaTitle: "Contact - GSplat Share",
			metaDescription: "Contact information for GSplat Share.",
			title: "Contact",
			subtitle: "Send issues about files, links, or supported formats.",
			intro: "Include the URL and file format when they are relevant.",
			email: "contact@gsplat.org",
			cards: [
				{ label: "Issues", value: "Broken links, failed uploads, or display problems." },
				{ label: "Formats", value: "PLY, SPZ, SOG, and SuperSplat HTML questions." },
				{ label: "Removal", value: "Requests about deleting or limiting share links." },
			],
			acceptedTitle: "Replies",
			acceptedBody: "This is an individual project, so replies may take time.",
		},
		pricing: {
			metaTitle: "Free beta - GSplat Share",
			metaDescription: "GSplat Share is currently available as a free beta.",
			title: "Free beta",
			subtitle: "No public pricing table or paid plan is available right now.",
			backHome: "Back to home",
		},
		privacy: {
			metaTitle: "Privacy Policy - GSplat Share",
			metaDescription: "Privacy policy for GSplat Share.",
			title: "Privacy Policy",
			subtitle: "How account and share-link information is handled.",
			sections: [
				{
					title: "Data collected",
					body: "Uploaded files, share-link settings, and sign-in email addresses may be processed.",
				},
				{ title: "Purpose", body: "Data is used to create, display, manage, and support share links." },
				{ title: "Third parties", body: "Data is not shared without consent except where required by law." },
				{ title: "Contact", body: "For privacy questions, contact contact@gsplat.org." },
			],
		},
		terms: {
			metaTitle: "Terms - GSplat Share",
			metaDescription: "Terms of use for GSplat Share.",
			title: "Terms",
			subtitle: "Please review before using GSplat Share.",
			sections: [
				{ title: "Use", body: "Use the service to share 3D data as browser-viewable links." },
				{
					title: "Prohibited use",
					body: "Do not upload infringing, illegal, or abusive content, or overload the service.",
				},
				{ title: "Visibility", body: "Users are responsible for managing link visibility, expiry, and passwords." },
				{ title: "Changes", body: "Because the service is in free beta, features and availability may change." },
			],
		},
	},
} as const;

export function getLegalCopy(locale: Locale) {
	return legalCopy[locale];
}
